<template>
  <div class="root">
    <input-field
      class="search-container mb-0"
      prefixIcon="search"
      classes="search-input mb-0"
      placeholder="Search All Products"
      ref="search"
      @focus="searchFocus"
      @blur="searchBlur"
      @keyup="searchKeyup"
    />
    <span class="f-btn" @click="openSort">
      <i class="material-icons">sort</i>
      <span>Sort</span>
    </span>
    <span class="f-btn" @click="openFilter">
      <i class="material-icons">filter_list</i>
      <span>Filter</span>
    </span>
  </div>
</template>

<script>
import InputField from "../../../../components/InputField.vue"

export default {
  name: "ProductHiddenActions",
  components: {
    InputField,
  },
  data() {
    return {
      search: null
    }
  },
  mounted() {
    this.search = this.$refs.search.$el;
  },
  methods: {
    searchKeyup(e) {
      this.$emit('search', e);
    },

    openSort() {
      this.$emit('openSort');
    },
    openFilter() {
      this.$emit('openFilter');
    },

    searchFocus() {
      this.search.classList.add('open')
    },
    searchBlur(e) {
      this.search.classList.remove('open')
      if (e.target.value === '')
        this.$emit('searchEnd')
    },
  }
}
</script>

<style lang="scss" scoped>
.root {
  position: absolute;
  left: 50%;
  top: 0;
  height: 54px;
  z-index: 999;
  display: flex;
  align-items: center;
  transform: translateX(-50%);

  .search-container {
    // width: 50px;
    transition: $transition-fast-out;

    @include tablet-and-up {
      width: 115px;

      &.open {
        width: 200px;
      }
    }

    @include laptop-and-up {
      width: 200px;
    }
  }

  .f-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 2px solid #e0e0e0;
    background-color: #e0e0e0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    transition: $transition-fast-out;
    padding: calc(.5rem - 1px) .75rem;
    margin-left: -2px;

    span {
      margin-left: 5px;
    }

    &:hover {
      color: white;
      // border-color: $primary-color;
      background-color: $primary-color;
    }

    &:last-child {
      margin-left: -2px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}
</style>

<style lang="scss">
.search-input {
  padding-right: 8px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.theme-dark .f-btn {
    border-color: #474747 !important;
    background-color: #e7e7e720 !important;

    &:hover {
      border-color: $primary-color !important;
      background-color: $primary-color !important;
    }
  }
</style>
